module.exports = __webpack_public_path__ + "static/media/favicon.d41d8cd9.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/favicon.ico
// module id = 911
// module chunks = 0